/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListenStreakReminderNotificationActionData } from './ListenStreakReminderNotificationActionData';
import {
    ListenStreakReminderNotificationActionDataFromJSON,
    ListenStreakReminderNotificationActionDataFromJSONTyped,
    ListenStreakReminderNotificationActionDataToJSON,
} from './ListenStreakReminderNotificationActionData';

/**
 * 
 * @export
 * @interface ListenStreakReminderNotificationAction
 */
export interface ListenStreakReminderNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof ListenStreakReminderNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ListenStreakReminderNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ListenStreakReminderNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {ListenStreakReminderNotificationActionData}
     * @memberof ListenStreakReminderNotificationAction
     */
    data: ListenStreakReminderNotificationActionData;
}

/**
 * Check if a given object implements the ListenStreakReminderNotificationAction interface.
 */
export function instanceOfListenStreakReminderNotificationAction(value: object): value is ListenStreakReminderNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function ListenStreakReminderNotificationActionFromJSON(json: any): ListenStreakReminderNotificationAction {
    return ListenStreakReminderNotificationActionFromJSONTyped(json, false);
}

export function ListenStreakReminderNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListenStreakReminderNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': ListenStreakReminderNotificationActionDataFromJSON(json['data']),
    };
}

export function ListenStreakReminderNotificationActionToJSON(value?: ListenStreakReminderNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': ListenStreakReminderNotificationActionDataToJSON(value.data),
    };
}

